import { useMemo } from 'react';
import { uniq } from 'lodash';
import Fireworks, { type FireworkTargetBounds } from './Fireworks';

export let FireworksOverlay = ({
  colors,
  active,
  targetBounds,
}: {
  colors: (string | null | undefined)[];
  active: boolean;
  targetBounds?: FireworkTargetBounds;
}) => {
  let filteredColors = useMemo(
    () => uniq(colors.filter((c): c is string => Boolean(c))),
    [colors],
  );

  return (
    <Fireworks
      colors={filteredColors}
      active={active}
      targetBounds={targetBounds}
      className="fixed inset-0 z-0"
    />
  );
};
